import { Navigate } from 'react-router-dom';

// /partner/mypage/password 는 본페이지 /partner/mypage 에서 모달(ChangePasswordModal)로 제공됨.
const ChangePassword = () => <Navigate to="/partner/mypage" replace />;

export default ChangePassword;
